import React, {useEffect, useState} from 'react';

import GameSettings from '../GameSettings/GameSettings';
import GameBoard from '../GameBoard/GameBoard';
import GameResult from '../GameResult/GameResult';
import './Plinko.css';

const minBetAmount = 0.01;

export default function App() {
  const [betAmount, setBetAmount] = useState(minBetAmount);
  const [ballsCount, setBallsCount] = useState(1);
  const [rows, setRows] = useState(12);
  const [risk, setRisk] = useState('medium');
  const [animation, setAnimation] = useState('On');
  const [sound, setSound] = useState('On');
  const [bet, setBet] = useState(0);
  const [gameStatus, setGameStatus] = useState(0);
  const [resultShow, setResultShow] = useState(false);
  const [payoutMultiple, setPayoutMultiple] = useState([]);
  const [outcome, setOutcome] = useState('');

  const betClick = (event) => {
    var tmp = bet + 1;
    setBet(tmp);
    tmp = gameStatus + 1;
    setGameStatus(tmp);
    setPayoutMultiple([]);
  }

  const gameStatusChange = (event) => {
    var tmp = gameStatus + 1;
    setGameStatus(tmp);
  }

  const hideResultModal = () => {
    setResultShow(false);
  }

  const multipleAdd = (payoutId) => {
    setPayoutMultiple(payoutMultiple => [...payoutMultiple, payoutId]);
  }

  useEffect(() => {
    // Show GameResult
    if (gameStatus && !(gameStatus % 2))
      setResultShow(true);
  }, [gameStatus]);

  return (
    <div className='plinko-board'>
      <GameSettings
        betAmount={betAmount} setBetAmount={setBetAmount}
        ballsCount={ballsCount} setBallsCount={setBallsCount}
        rows={rows} setRows={setRows}
        risk={risk} setRisk={setRisk}
        animation={animation} setAnimation={setAnimation}
        sound={sound} setSound={setSound}
        outcome={outcome} setOutcome={setOutcome}
        betClick={betClick}
        gameStatus={gameStatus}
      />
      <GameBoard
        ballsCount={ballsCount}
        rows={rows}
        risk={risk}
        animation={animation}
        sound={sound}
        outcome={outcome}
        bet={bet}
        gameStatusChange={gameStatusChange}
        multipleAdd={multipleAdd}
      />
      <div className='game-settings game-result'>
        <GameResult
          betAmount={betAmount}
          ballsCount={ballsCount}
          rows={rows}
          risk={risk}
          show={resultShow}
          handleClose={hideResultModal}
          payoutMultiple={payoutMultiple}
        />
      </div>
    </div>
  );
}
